import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@reflex/ui/components/ui/button';

interface BackLinkButtonProps {
  /** Destination route. */
  to: string;
  /** Visible label rendered next to the arrow. Defaults to `'Back'`. */
  label?: string;
  /** Accessible label. Defaults to `'Go back'`. */
  ariaLabel?: string;
}

/**
 * Compact ghost back-link for nested detail pages (list ↔ detail inside a
 * surface). Sits above `PageHeader` as a parent-collection crumb
 * (`Teams`, `Roles`), not a full-width outline button. No `esc` hint —
 * takeover shells own Esc via `BackChip`.
 */
export function BackLinkButton({ to, label = 'Back', ariaLabel = 'Go back' }: BackLinkButtonProps) {
  return (
    <Button asChild variant="ghost" size="sm" className="-ml-2 self-start text-muted-foreground">
      <Link to={to} aria-label={ariaLabel}>
        <ArrowLeft className="icon-sm" />
        {label}
      </Link>
    </Button>
  );
}
